export default "__VITE_ASSET__17b41fcd__"